"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@rahtab/ui");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Screen_1 = __importDefault(require("./Screen"));
/** @deprecated use ListScreen from @rahtab/system */
function ListScreen({ data = undefined, headerShown = true, loading = false, transparentLoading = false, title, style, ListEmptyComponent, renderControls, renderHeader, listData = [], renderItem, numColumns = 1, contentContainerStyle, ...props }) {
    return (react_1.default.createElement(Screen_1.default, { title: title, data: data, loading: loading, transparentLoading: transparentLoading, renderControls: renderControls, style: react_native_1.StyleSheet.flatten([style]), 
        /**@todo fix renderMain type */
        //@ts-ignore
        renderMain: () => {
            return (react_1.default.createElement(react_native_1.FlatList, Object.assign({ data: listData, columnWrapperStyle: numColumns !== 1 && styles.columnWrapperStyle, contentContainerStyle: react_native_1.StyleSheet.flatten([
                    contentContainerStyle,
                    ui_1.getFlatListEmptyContentContainerStyle(listData),
                ]), ListEmptyComponent: ListEmptyComponent, renderItem: renderItem, numColumns: numColumns }, props)));
        } }));
}
exports.default = ListScreen;
const styles = react_native_1.StyleSheet.create({
    columnWrapperStyle: {
        paddingHorizontal: ui_1.getSpacing(0.5),
    },
});
